/*
 * Why are these capitalized? Because `delete` is a keyword in javascript and
 * cannot be used for a function name.
 */

let games = process.env.NODE_ENV === "production" ? "games" : "schmames";
let baseUrl = `https://bbtf-tourney.firebaseio.com`;
let exitPollsUrl = (gameNumber) => `${baseUrl}/games/${gameNumber}/votes.json`;

let votingUrl = (gameNumber, voter) =>
  `${baseUrl}/${games}/${gameNumber}/votes/${voter}.json`;

let writeupsUrl = (gameNumber) => `${baseUrl}/matchups/${gameNumber}.json`;

let submitWriteupUrl = (gameNumber, writeupLabel) =>
  `${baseUrl}/matchups/${gameNumber}/${writeupLabel}.json`;

// TODO: put the whole vote object in the list, not just the winner name, so rationales can be
// displayed along with the raw results after voting closes
export function getVotes(gameNumber) {
  let cleanRawVotes = (rawVotes) => {
    let cleanedVotes = {};
    for (let voter in rawVotes) {
      let winner, rationale;
      for (let name in rawVotes[voter]) {
        winner = rawVotes[voter][name].winner;
        rationale = rawVotes[voter][name].rationale;
      }

      cleanedVotes = { ...cleanedVotes, [voter]: { voter, winner, rationale } };
    }
    return cleanedVotes;
  };

  return fetch(exitPollsUrl(gameNumber))
    .then((response) => response.json())
    .then(cleanRawVotes);
}

export function vote(gameNumber, voter, winner, rationale) {
  if (!voter || !winner)
    throw new Error(
      `Need both voter and winner: gave voter ${voter} and winner ${winner}`
    );

  let maybeRationale = rationale ? { rationale } : {};
  let body = JSON.stringify({ winner, ...maybeRationale });

  return fetch(votingUrl(gameNumber, voter), {
    method: "POST",
    body,
  }).then((response) => response.json());
}

export function getWriteups(gameNumber) {
  return fetch(writeupsUrl(gameNumber)).then((response) => response.json());
}

export function submitWriteup(gameNumber, writeupLabel, text) {
  if (writeupLabel !== "writeupA" && writeupLabel !== "writeupB") {
    console.error("wtf is", writeupLabel);
    return new Promise(null);
  } else {
    return fetch(submitWriteupUrl(gameNumber, writeupLabel), {
      method: "PUT",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(text),
    }).then((response) => response.json());
  }
}

/**
 * UTILITIES THO
 */
export function put(url, payload) {
  let body = JSON.stringify(payload);

  return fetch(baseUrl + url, {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    body,
  }).then((response) => response.json());
}
